// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { InventoryProjection } from './inventory-projection';
import { InventoryProjectionLinePart } from './inventory-projection-line-part';
import { Part } from './part';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InventoryProjectionLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created?: Date;
  deleted?: Date;
  description?: string;
  inventoryProjectionId!: number;
  lineNumber!: number;
  notes?: string;
  partId?: number;
  partNumber?: string;
  quantity!: number;
  inventoryProjection!: InventoryProjection;
  part!: Part;
  parts!: InventoryProjectionLinePart[];
}

